import { IngredientsEnum } from "../../scenes/BurgerScene";
import { BurgerManager } from "./BurgerManager";
import { Ingredient } from "./Ingredient";

export interface IngredientConfig {
    ingredient: IngredientsEnum,
    spawn: {x: number, y: number},
    texture: string,
    shadow_texture: string,
    height: number,
    depth: number,
    origin: {x: number, y: number},
}

export class IngredientSpawner {
    private burger : BurgerManager;
    private config : IngredientConfig;
    private scene : Phaser.Scene;

    private currentIngredient : Ingredient;

    constructor(config: IngredientConfig, burger: BurgerManager, scene: Phaser.Scene){
        this.burger = burger;
        this.config = config;
        this.scene = scene;

        this.currentIngredient = this.spawnNewIngredient(); 
    }

    private spawnNewIngredient() : Ingredient {
        return new Ingredient(this.config, this.scene, this);
    }

    onIngredientDropped(x: number, y: number) {
        if (this.burger.isInRange(x, y)){
            this.burger.addIngredient(this.currentIngredient);
            this.currentIngredient = this.spawnNewIngredient();

        } else {
            this.currentIngredient.moveToSpawn();
        }
    }

    public disable(){
        this.currentIngredient.isDragging = false;
        this.currentIngredient.disableInteractive();
        this.currentIngredient.moveToSpawn();
    }
}